function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { useField, useFormikContext } from 'formik';
import React from 'react';
import { FormGroup } from 'reactstrap';
import { Error, Label, Radio } from "./";
export default (function (_ref) {
  var name = _ref.name,
      label = _ref.label,
      inline = _ref.inline,
      value = _ref.value,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'sm' : _ref$size,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      _ref$optionsValuesTyp = _ref.optionsValuesType,
      optionsValuesType = _ref$optionsValuesTyp === void 0 ? 'string' : _ref$optionsValuesTyp,
      _ref$emptyMeansNull = _ref.emptyMeansNull,
      emptyMeansNull = _ref$emptyMeansNull === void 0 ? true : _ref$emptyMeansNull,
      _ref$nullable = _ref.nullable,
      nullable = _ref$nullable === void 0 ? true : _ref$nullable,
      _ref$groupTag = _ref.groupTag,
      groupTag = _ref$groupTag === void 0 ? FormGroup : _ref$groupTag,
      _ref$labelTag = _ref.labelTag,
      labelTag = _ref$labelTag === void 0 ? Label : _ref$labelTag,
      _ref$errorTag = _ref.errorTag,
      errorTag = _ref$errorTag === void 0 ? Error : _ref$errorTag,
      _ref$inputTag = _ref.inputTag,
      inputTag = _ref$inputTag === void 0 ? Radio : _ref$inputTag,
      _ref$groupProps = _ref.groupProps,
      groupProps = _ref$groupProps === void 0 ? {} : _ref$groupProps,
      _ref$labelProps = _ref.labelProps,
      labelProps = _ref$labelProps === void 0 ? {} : _ref$labelProps,
      _ref$inputProps = _ref.inputProps,
      inputProps = _ref$inputProps === void 0 ? {} : _ref$inputProps,
      _ref$errorProps = _ref.errorProps,
      errorProps = _ref$errorProps === void 0 ? {} : _ref$errorProps;

  var _useFormikContext = useFormikContext(),
      mapping = _useFormikContext.mapping;

  var fieldContext = useField({
    name: name
  });
  var radiosContainerClassName = getContainerClassName(inline);
  var GroupTag = groupTag;
  var LabelTag = labelTag;
  var ErrorTag = errorTag;
  var InputTag = inputTag;
  label = labelProps.text || label;

  if (label === undefined) {
    label = name;
  }

  if (!Array.isArray(options)) {
    options = mapping.getChoices(name);
  }

  return /*#__PURE__*/React.createElement(GroupTag, groupProps, label && /*#__PURE__*/React.createElement(LabelTag, _extends({
    name: name,
    size: size
  }, labelProps), label), /*#__PURE__*/React.createElement("div", {
    className: radiosContainerClassName
  }, options.map(function (item, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: name + i,
      className: inline ? 'mr-4' : ''
    }, /*#__PURE__*/React.createElement(InputTag, _extends({
      id: name + i,
      name: name + i,
      label: item.label,
      value: item.value,
      groupTag: inline ? React.Fragment : undefined,
      displayErrors: false,
      checked: String(item.value) === String(value === undefined ? fieldContext[0].value : value),
      onChange: function onChange(_ref2) {
        var currentTarget = _ref2.currentTarget;
        fieldContext[2].setValue(castValue(currentTarget.value, optionsValuesType, emptyMeansNull, nullable));
      }
    }, inputProps)));
  })), /*#__PURE__*/React.createElement(ErrorTag, _extends({
    name: name
  }, errorProps)));
});

var getContainerClassName = function getContainerClassName(inline) {
  var className = '';

  if (inline) {
    className += 'flex align-items-center';

    switch (inline) {
      case 'center':
        className += ' justify-content-center';
        break;

      case 'end':
        className += ' justify-content-end';
        break;

      case 'start':
        className += ' justify-content-start';
        break;

      default:
        break;
    }
  }

  return className;
};

var castValue = function castValue(value, type, emptyMeansNull, nullable) {
  if (emptyMeansNull && value === '' || nullable && value === 'null') {
    return null;
  }

  switch (type) {
    case 'string':
      return String(value);

    case 'number':
      return Number(value);

    case 'bool':
    case 'boolean':
      if (value === 'true') {
        value = 1;
      }

      if (value === 'false') {
        value = 0;
      }

      return Boolean(value);

    default:
      return value;
  }
};